// The one place this app leaves itself.
//
// Both ends of a session are BROWSER navigations, not fetches. `/api/auth/session/login`
// ends in a 302 to Keycloak (see `loginUrl`), and Keycloak's logout endpoint is
// the same story in reverse (see `useSignOut`) — an XHR would follow either into
// a CORS wall, and in the logout case would not touch the SSO cookie that is the
// entire point of going there. So both are `location.assign`, and this module
// exists so that call has a name — jsdom throws "Not implemented: navigation" on
// it, and a test that asserts where the app sent the user should not have to stub
// a global.

/** Leave the SPA for `url`, adding a history entry. */
export function assignLocation(url: string): void {
  window.location.assign(url);
}
